import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import { useState, useCallback } from 'react';
export function useReplyState() {
    const [replyingComments, setReplyingComments] = useState({});
    const onEditingStateChange = useCallback((commentId, state)=>(replyState)=>{
            const { [commentId]: value } = replyState, rest = _object_without_properties(replyState, [
                commentId
            ].map(_to_property_key));
            if (state === 'replying') {
                setReplyingComments(_object_spread_props(_object_spread({}, rest), {
                    [commentId]: true
                }));
            } else {
                setReplyingComments(rest);
            }
        }, []);
    const isReplyingToComment = useCallback((parentId)=>!!replyingComments[parentId], [
        replyingComments
    ]);
    return {
        onEditingStateChange,
        isReplyingToComment
    };
}

//# sourceMappingURL=useReplyState.js.map